import React, { Fragment, useState, useEffect } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { Container, Logo, PreHeader } from '@scentregroup/ui'
import CVPStrip from '../../hub-components/cvp-strip'
import { getDefaultCentreMetadata } from '../../helpers/get-default-centre-metadata'
import CentreFooter from '../../components/centre-footer'
import OldHeader from '../../components/header'
import { UniversalFooter } from '../../components/universal-footer'
import FeedbackButton from '../../components/feedback-button'
import withCentre from '../../containers/with-centre'
import { centreType } from '../../types'
import pagesHoc from '../pages-hoc'
import CentrePattern from '../../components/centre-pattern'
import {
  TimeZoneContext,
  CustomThemeContext,
  BasicPageContext,
  AgentInfoContext,
  useCountryContext,
} from '../../context'
import { TouchEventDetection } from '../../helpers/with-touch-detection'
import { useRecentCentresTracker } from '../../hooks/use-recent-centres'
import { useUniversalHeader } from '../../hub-components/universal-header'
import style from './index.module.scss'

const isMapPage = location => location.pathname.includes('centre-map')
const shouldAnimateW = true

const CentrePage = ({
  headerStaticData,
  centre,
  isEvolved = false,
  children,
  location,
}) => {
  const country = useCountryContext()

  const [Header, setHeaderNavigationPath] = useUniversalHeader({
    variant: 'centre',
    data: headerStaticData,
  })

  useRecentCentresTracker(centre)
  const [firstPage, setFirstPage] = useState(shouldAnimateW)
  useEffect(() => {
    if (firstPage) {
      setFirstPage(false)
    }
  }, [firstPage, location.pathname])
  const preHeaderColour =
    centre.bespoke && centre.bespoke.luxury ? 'minimal' : 'seasonal'
  return (
    <BasicPageContext.Consumer>
      {isBasicPage => (
        <TimeZoneContext.Provider value={centre.timeZone}>
          <CustomThemeContext.Provider value={centre.bespoke}>
            <TouchEventDetection className="fullHeightForMap">
              {!isBasicPage &&
                (isEvolved ? (
                  <>
                    <CVPStrip />
                    <Header />
                  </>
                ) : (
                  <Fragment>
                    <CentrePattern slug={centre.slug} />
                    <AgentInfoContext.Consumer>
                      {({ isMobile }) =>
                        (!isMapPage(location) || !isMobile) && (
                          <PreHeader colour={preHeaderColour}>
                            <Link
                              to="/"
                              title="Home"
                              className={style.headerLogo}
                            >
                              <Logo />
                            </Link>
                          </PreHeader>
                        )
                      }
                    </AgentInfoContext.Consumer>
                    <OldHeader
                      isCentreHome
                      centre={centre}
                      navigationMenu={centre.navigationMenu}
                    />
                  </Fragment>
                ))}
              <Container className={classNames('fullHeightForMap')}>
                {children({ centre, firstPage })}
              </Container>

              {!isBasicPage && (
                <Fragment>
                  <div id="search-modal" />
                  {!isMapPage(location) && (
                    <Fragment>
                      {isEvolved ? (
                        <UniversalFooter
                          Link={Link}
                          centre={centre}
                          country={country}
                          onFindACentre={() =>
                            setHeaderNavigationPath(['find-a-centre'])
                          }
                        />
                      ) : (
                        <CentreFooter centre={centre} />
                      )}
                      <FeedbackButton emailAddress={centre.emailAddress} />
                    </Fragment>
                  )}
                </Fragment>
              )}
            </TouchEventDetection>
          </CustomThemeContext.Provider>
        </TimeZoneContext.Provider>
      )}
    </BasicPageContext.Consumer>
  )
}

CentrePage.propTypes = {
  centre: centreType,
  location: PropTypes.object,
  children: PropTypes.func.isRequired,
  isEvolved: PropTypes.bool,
  headerStaticData: PropTypes.object,
}

export const RawCentrePage = CentrePage

export const CentreShell = withRouter(
  withCentre(pagesHoc(RawCentrePage, getDefaultCentreMetadata))
)
